/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './intra-op-chart.reducer';

export const IntraOPChart = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const intraOPChartList = useAppSelector(state => state.intraOPChart.entities);
  const loading = useAppSelector(state => state.intraOPChart.loading);
  const totalItems = useAppSelector(state => state.intraOPChart.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="intra-op-chart-heading" data-cy="IntraOPChartHeading">
        <Translate contentKey="tinyMedicRestApp.intraOPChart.home.title">Intra OP Charts</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.intraOPChart.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/intra-op-chart/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.intraOPChart.home.createLabel">Create new Intra OP Chart</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.intraOPChart.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {intraOPChartList && intraOPChartList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('oxygen')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.oxygen">Oxygen</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('oxygen')} />
                </th>
                <th className="hand" onClick={sort('nitrousOxide')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.nitrousOxide">Nitrous Oxide</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('nitrousOxide')} />
                </th>
                <th className="hand" onClick={sort('halothane')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.halothane">Halothane</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('halothane')} />
                </th>
                <th className="hand" onClick={sort('isoflurane')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.isoflurane">Isoflurane</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('isoflurane')} />
                </th>
                <th className="hand" onClick={sort('sevoflurane')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.sevoflurane">Sevoflurane</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sevoflurane')} />
                </th>
                <th className="hand" onClick={sort('desflurane')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.desflurane">Desflurane</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('desflurane')} />
                </th>
                <th className="hand" onClick={sort('invasiveLines')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.invasiveLines">Invasive Lines</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('invasiveLines')} />
                </th>
                <th className="hand" onClick={sort('urineOutput')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.urineOutput">Urine Output</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('urineOutput')} />
                </th>
                <th className="hand" onClick={sort('bloodLoss')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.bloodLoss">Blood Loss</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodLoss')} />
                </th>
                <th className="hand" onClick={sort('otherLosses')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.otherLosses">Other Losses</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('otherLosses')} />
                </th>
                <th className="hand" onClick={sort('opVentilation')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.opVentilation">Op Ventilation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('opVentilation')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.anaesthesiologist">Anaesthesiologist</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.surgeon">Surgeon</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.nurse">Nurse</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.vitals">Vitals</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.intraOPChart.preOpAnaesthesiaChart">Pre Op Anaesthesia Chart</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {intraOPChartList.map((intraOPChart, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/intra-op-chart/${intraOPChart.id}`} color="link" size="sm">
                      {intraOPChart.id}
                    </Button>
                  </td>
                  <td>{intraOPChart.oxygen}</td>
                  <td>{intraOPChart.nitrousOxide}</td>
                  <td>{intraOPChart.halothane}</td>
                  <td>{intraOPChart.isoflurane}</td>
                  <td>{intraOPChart.sevoflurane}</td>
                  <td>{intraOPChart.desflurane}</td>
                  <td>{intraOPChart.invasiveLines}</td>
                  <td>{intraOPChart.urineOutput}</td>
                  <td>{intraOPChart.bloodLoss}</td>
                  <td>{intraOPChart.otherLosses}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.OPVentilation.${intraOPChart.opVentilation}`} />
                  </td>
                  <td>{intraOPChart.active ? 'true' : 'false'}</td>
                  <td>{intraOPChart.cursor}</td>
                  <td>{intraOPChart.lastupdated}</td>
                  <td>{intraOPChart.microSec}</td>
                  <td>{intraOPChart.timestampentry}</td>
                  <td>
                    {intraOPChart.surgery ? (
                      <Link to={`/patient-procedure/${intraOPChart.surgery.id}`}>{intraOPChart.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {intraOPChart.patient ? <Link to={`/gluco-user/${intraOPChart.patient.id}`}>{intraOPChart.patient.id}</Link> : ''}
                  </td>
                  <td>
                    {intraOPChart.anaesthesiologist ? (
                      <Link to={`/doctor/${intraOPChart.anaesthesiologist.id}`}>{intraOPChart.anaesthesiologist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{intraOPChart.surgeon ? <Link to={`/doctor/${intraOPChart.surgeon.id}`}>{intraOPChart.surgeon.id}</Link> : ''}</td>
                  <td>{intraOPChart.nurse ? <Link to={`/nurse/${intraOPChart.nurse.id}`}>{intraOPChart.nurse.id}</Link> : ''}</td>
                  <td>{intraOPChart.vitals ? <Link to={`/vitals/${intraOPChart.vitals.id}`}>{intraOPChart.vitals.id}</Link> : ''}</td>
                  <td>
                    {intraOPChart.preOpAnaesthesiaChart ? (
                      <Link to={`/pre-op-anaesthesia-chart/${intraOPChart.preOpAnaesthesiaChart.id}`}>
                        {intraOPChart.preOpAnaesthesiaChart.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/intra-op-chart/${intraOPChart.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/intra-op-chart/${intraOPChart.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/intra-op-chart/${intraOPChart.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.intraOPChart.home.notFound">No Intra OP Charts found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={intraOPChartList && intraOPChartList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default IntraOPChart;
